import { useTranslation } from 'react-i18next';

import { ShcLogo } from '@/components/brand/ShcLogo';

interface Props {
  kind: 'loading' | 'failed' | 'ended';
}

/**
 * Full-page notice for the EMR bridge (SHCT-994): exchanging, refused, or ended. No link back into the app — an EMR
 * session is re-opened from the EMR button only (api-contracts/emr-bridge.md §A.5). The refusal never says why: the
 * cause is kept in the audit log only, so the same text covers every 401·429·network failure.
 */
export function EmrNotice({ kind }: Props) {
  const { t } = useTranslation(['medical', 'common']);
  return (
    <main className='login-page login-page--medical'>
      <div className='login-page__container'>
        <div className='login-page__logo'>
          <div className='login-page__logo-icon'>
            <ShcLogo size={28} />
          </div>
          <h1 className='login-page__logo-text'>{t('common:gnb.brand')}</h1>
        </div>
        <p className='login-page__subtitle' role={kind === 'loading' ? 'status' : 'alert'}>
          {t(`medical:emr.notice.${kind}.title`)}
        </p>
        {kind !== 'loading' && <p>{t(`medical:emr.notice.${kind}.body`)}</p>}
      </div>
    </main>
  );
}
